//@ts-nocheck
/*
  TODO: Flag retirement plan (enableNewPaymentPlans -> baseline)
  - Remove feature flag branching and always use the new calculator.
  - Option A: Delete this adapter and update all imports to
    `import { calculatePaymentScheduleNew as getBookingPaymentPlan } from './paymentScheduleNew'`.
  - Option B (temporary): Keep this adapter but re-export the new
    calculator directly without branching, then remove once call sites
    stop importing the adapter.
  - Delete the legacy util './paymentSchedule' and its tests after
    migrating call sites.
  - Search & replace helpers:
      rg "getBookingPaymentPlan\(" XG-FE/src
      rg "getPaymentSchedule\(" XG-FE/src
*/
import { getPaymentSchedule } from './paymentSchedule';
import { calculatePaymentScheduleNew } from './paymentScheduleNew';

// Unified adapter to choose legacy vs new logic based on feature flag.
// Returns the richer new-logic shape regardless, to simplify callers.
// shape: { canBook, mustPayInFull, dueAtBooking, schedule, totalPrice, reasons? }
export const getBookingPaymentPlan = ({
  tripStartDate,
  bookingCreationDate,
  bookingPlans = [],
  paymentPlan,
  bookingAddOns = [],
  priceAdjustment = 0,
  featureFlags = {}
}) => {
  if (featureFlags.enableNewPaymentPlans) {
    return calculatePaymentScheduleNew({
      tripStartDate,
      bookingCreationDate,
      bookingPlans,
      paymentPlan,
      priceAdjustment,
      bookingAddOns
    });
  }

  // Legacy path: adapt existing schedule to the new shape
  const legacy = getPaymentSchedule({
    tripStartDate,
    bookingCreationDate,
    bookingPlans,
    paymentPlan
  });

  if (legacy.notBookable) {
    return {
      canBook: false,
      mustPayInFull: false,
      dueAtBooking: 0,
      schedule: [],
      totalPrice: 0,
      reasons: [legacy.reason || 'not_bookable']
    };
  }

  const totalPrice =
    Math.round(
      legacy.schedule.reduce((acc, s) => acc + Number(s.amount || 0), 0) * 100
    ) / 100;

  // Partition into due today vs future by booking date
  const dueToday = legacy.schedule.filter(
    (x) => x.date && x.date <= bookingCreationDate
  );
  const future = legacy.schedule.filter((x) => x.date > bookingCreationDate);

  const dueAtBooking =
    Math.round(
      dueToday.reduce((acc, s) => acc + Number(s.amount || 0), 0) * 100
    ) / 100;

  const mustPayInFull = Math.abs(dueAtBooking - totalPrice) < 0.005;

  return {
    canBook: true,
    mustPayInFull,
    dueAtBooking: mustPayInFull ? totalPrice : dueAtBooking,
    schedule: mustPayInFull ? [] : future,
    totalPrice
  };
};

export default getBookingPaymentPlan;
